import "./IntegrationNew.scss";
import Typography from "app/shared/Typography";
import { Button, message, Modal, Tag, Segmented, Input } from "antd";
import { CheckCircleFilled, CloseCircleFilled, ExclamationCircleFilled, ClockCircleFilled, LoadingOutlined, SearchOutlined, } from "@ant-design/icons";
import { useEffect, useState, useRef } from "react";
import { apiGet } from "app/services/apiServices";
import { useRecoilState } from "recoil";
import { userInfo } from "app/config/States/users";
import { API_ENDPOINT_FETCH_AIRLINE_CREDENTIALS_LIST, } from "../Credentials/credentials.constants";
import { AgTableClient } from "app/shared/AgTable";
import Uploader from "app/shared/Uploader";
import { CellValueChangedEvent } from "ag-grid-enterprise";
import _cloneDeep from "lodash/cloneDeep";
import axios from "axios";
//import * as csv from "csvtojson";
import csv from 'csvtojson';
import type { UploadFile } from 'antd/es/upload/interface';
import * as XLSX from 'xlsx';
import { apiPost } from "app/services/apiServices";
import DownloadIcon from '@mui/icons-material/Download';
import { API_ENDPOINT_CREDENTIAL_ADD_BULK } from "./integrationnew.constants";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { ICellRendererParams } from 'ag-grid-enterprise'
import ErrorIcon from "@mui/icons-material/Error";
import { FinkAnalytics } from "app/utils/GoogleAnalytics";
import { getSubdomain } from "app/utils/generic.helper";




export default function IntegrationNew() {
  const gridRef = useRef<any>(null);
  const [userDetails] = useRecoilState<any>(userInfo);
  const [messageApi, contextHolder] = message.useMessage();
  const [rowData, setRowData] = useState<any[]>([]);
  const [isBulkModalVisible, setIsBulkModalVisible] = useState(false);
  const [changedRows, setChangedRows] = useState<any[]>([]);
  const [gridApi, setGridApi] = useState<any>(null);
  const [originalData, setOriginalData] = useState<any[]>([]);
  const [uploadedData, setUploadedData] = useState<any[]>([]);
  const [integrating, setIntegrating] = useState(false);
  const [panList, setPanList] = useState<any[]>([]);
  const [filteredPANS, setFilteredPANS] = useState<any[]>([]);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [airlineRefreshTimerId, setAirlineRefreshTimerId] = useState<ReturnType<typeof setInterval> | null>(null);
  const [activeSegment, setActiveSegment] = useState("FAILED");
  const [refreshTimerId, setRefreshTimerId] = useState<ReturnType<typeof setInterval> | null>(null);
  const isMounted = useRef(true);
  const [isLoading, setLoading] = useState(true);
  const [globalSearch, setGlobalSearch] = useState("");
  const pendingUpdatesRef = useRef<Set<string>>(new Set());
  const [showResolutionPopup, setShowResolutionPopup] = useState(false);
  const [resolvedRows, setResolvedRows] = useState<any[]>([]);
  const domain = getSubdomain();
  const getCredentialStatus = (
    valid: boolean | "Pending" | null,
    portal_id: string | number | null,
    portal_pass: string | number | null,
    pendingUpdate?: boolean
  ): "Valid" | "Wrong Credential" | "Not Available" | "Pending" => {
    if (pendingUpdate) {
      return "Pending";
    }
    if (valid === true) {
      return "Valid";
    }
    if (valid === false) {
      const isPortalIdEmpty = portal_id === null || portal_id === 0 || portal_id === "";
      const isPortalPassEmpty = portal_pass === null || portal_pass === 0 || portal_pass === "";
      if (isPortalIdEmpty && isPortalPassEmpty) {
        return "Not Available";
      } else {
        return "Wrong Credential";
      }
    }
    return "Not Available";
  };


  const sanitizeForBackend = (obj: any): any => {
    const sanitized: any = {};
    for (const [key, value] of Object.entries(obj)) {
      if (value === null || value === undefined) {
        sanitized[key] = null;
        continue;
      }
      const strValue = String(value).trim();
      if (strValue === "" || strValue === "0" || strValue.toLowerCase() === "na") {
        sanitized[key] = null;
      } else {
        sanitized[key] = value;
      }
    }
    return sanitized;
  };


  const columnDefs = [
    { field: "id", headerName: "Id", minWidth: 200, hide: true },
    ...(userDetails?.currentWorkspace?.meta?.full_access === true && domain !== "sunpharma"
      ? [
        {
          headerName: "Workspace Name",
          field: "workspace_name",
          minWidth: 200,
          filter: "agTextColumnFilter",
          rowGroup: true,
          hide: true,
          enableRowGroup: true,
        },
      ]
      : []),
    {
      field: "airline_name",
      headerName: "Airlines",
      minWidth: 200,
      enableRowGroup: true,
      //rowGroup: userDetails?.currentWorkspace?.meta?.full_access === true,
    },
    { field: "pan", headerName: "PAN", filter: "agTextColumnFilter", minWidth: 200, enableRowGroup: true, },
    {
      field: "portal_id",
      headerName: "Username",
      editable: true,
      enableRowGroup: true,
      filter: 'agTextColumnFilter',
      valueParser: (params: any) => (params.newValue ?? "").toString().trim(),
      valueGetter: (params: any) => {
        const value = params.data?.portal_id;
        return value === undefined || value === null || value === 0 ? '' : value;
      },
      cellRenderer: (params: any) => {
        if (params?.node?.group) {
          return params.value;
        }
        const value = params.value;
        const isEmpty = value === '' || value === undefined || value === null || value === 0;

        return (
          <span style={{ color: isEmpty ? "#aaa" : "#000" }}>
            {isEmpty ? "Enter username" : value}
          </span>
        );
      }
    },
    {
      field: "portal_pass",
      headerName: "Password",
      minWidth: 200,
      editable: true,
      enableRowGroup: true,
      valueParser: (params: any) => (params.newValue ?? "").toString().trim(),
      // Treat null/undefined/0 as empty
      valueGetter: (params: any) => {
        const rawValue = params.data?.portal_pass;
        return rawValue === null || rawValue === undefined || rawValue === 0 ? "" : String(rawValue);
      },
      filter: 'agTextColumnFilter',
      valueFormatter: (params: any) => {
        const rawValue = params.value;
        if (!rawValue) return "Enter password";




        const value = String(rawValue);
        const visiblePart = value.slice(-3);
        const maskedPart = "*".repeat(Math.max(0, value.length - 3));
        return maskedPart + visiblePart;
      },
      //},




      // Render masked password
      cellRenderer: (params: ICellRendererParams) => {
        if (params?.node?.group) {
          return params.value;
        }
        const rawValue = params.value;
        const isEmpty = rawValue === null || rawValue === undefined || rawValue === "" || rawValue === 0;





        if (isEmpty) {
          return <span style={{ color: "#aaa" }}>Enter password</span>;
        }




        const value = String(rawValue);
        const visiblePart = value.slice(-3);
        const maskedPart = "*".repeat(Math.max(0, value.length - 3));




        return maskedPart + visiblePart;
      }
    },
    
    {
      field: "code",
      headerName: "App Code",
      minWidth: 200,
      enableRowGroup: true,
      // Only editable if airline not in "not required" list
      editable: (params: any) => {
        const airline = params.data?.airline_name?.toLowerCase?.();
        const notRequiredAirlines = ["airindia", "klm", "airfrance", "aircanada"];
        return !notRequiredAirlines.includes(airline);
      },
      // No need to insert "__NOT_REQUIRED__" here
      valueGetter: (params: any) => {
        const code = params.data?.code;
        return code || "";
      },
      cellClassRules: {
        "no-padding-cell": (params: any) => {
          const airline = params.data?.airline_name?.toLowerCase?.();
          const code = params.data?.code;
          const notRequiredAirlines = ["airindia", "klm", "airfrance", "aircanada"];
          return notRequiredAirlines.includes(airline) && (!code || code === "");
        },
      },
      // Prevent grid from showing raw "__NOT_REQUIRED__"
      valueFormatter: () => "",
      cellRenderer: (params: ICellRendererParams) => {
        if (params?.node?.group) {
          return params.value;
        }
        const airline = params.data?.airline_name?.toLowerCase?.();
        const code = params.data?.code;
        const notRequiredAirlines = ["airindia", "klm", "airfrance", "aircanada"];
        const isNotRequired =
          notRequiredAirlines.includes(airline) && (!code || code === "");
        const isEmpty = !code;
        if (isNotRequired) {
          return (
            <span
              id="disable-cell"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                color: "#808080",
                fontSize: "14px",
                border: "1px solid var(--Neutral-300, #E8EAF1)",
                background: "rgba(128, 128, 128, 0.10)",
                padding: "2px 6px",
                borderRadius: "4px",
                width: "200px",
              }}
            >
              <ErrorIcon fontSize="small" />
              Not Required
            </span>
          );
        }
        return (
          <span style={{ color: isEmpty ? "#aaa" : "#000" }}>
            {isEmpty ? "Enter code" : code}
          </span>
        );
      },
    },
    {
      field: "otp_email",
      headerName: "OTP Email",
      minWidth: 200,
      enableRowGroup: true,
      editable: (params: any) => {
        const airline = params.data?.airline_name?.toLowerCase?.();
        const notRequiredAirlines = ["klm", "airfrance", "aircanada"];
        return !notRequiredAirlines.includes(airline);
      },
      valueGetter: (params: any) => {
        const airline = params.data?.airline_name?.toLowerCase?.();
        const otpEmail = params.data?.otp_email;
        const notRequiredAirlines = ["klm", "airfrance", "aircanada"];
        if (notRequiredAirlines.includes(airline) && (!otpEmail || otpEmail === "")) {
          return "__NOT_REQUIRED__";
        }
        return otpEmail || "";
      },
      cellClassRules: {
        "no-padding-cell": (params: any) => {
          const airline = params.data?.airline_name?.toLowerCase?.();
          const otpEmail = params.data?.otp_email;
          const notRequiredAirlines = ["klm", "airfrance", "aircanada"];
          return notRequiredAirlines.includes(airline) && (!otpEmail || otpEmail === "");
        },
      },
      cellRenderer: (params: ICellRendererParams) => {
        if (params?.node?.group) {
          return params.value;
        }
        const value = params.value;
        const isNotRequired = value === "__NOT_REQUIRED__";
        const isEmpty = !value || value === "";
        if (isNotRequired) {
          return (
            <span
              id="disable-cell"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                color: "#808080",
                fontSize: "14px",
                border: "1px solid var(--Neutral-300, #E8EAF1)",
                background: "rgba(128, 128, 128, 0.10)",
                padding: "2px 6px",
                borderRadius: "4px",
                width: "200px",
              }}
            >
              <ErrorIcon fontSize="small" />
              Not Required
            </span>
          );
        }
        return (
          <span style={{ color: isEmpty ? "#aaa" : "#000" }}>
            {isEmpty ? "Enter OTP email" : value}
          </span>
        );
      },
    },
    {
      field: "otp_pass",
      headerName: "OTP Email Password",
      minWidth: 200,
      enableRowGroup: true,
      editable: (params: any) => {
        const airline = params.data?.airline_name?.toLowerCase?.();
        const notRequiredAirlines = ["klm", "airfrance", "aircanada"];
        return !(notRequiredAirlines.includes(airline));
      },
      valueGetter: (params: any) => {
        const airline = params.data?.airline_name?.toLowerCase?.();
        const otpPass = params.data?.otp_pass;
        const notRequiredAirlines = ["klm", "airfrance", "aircanada"];
        if (notRequiredAirlines.includes(airline) && (!otpPass || otpPass === "")) {
          return "__NOT_REQUIRED__";
        }
        return otpPass || "";
      },
      cellClassRules: {
        "no-padding-cell": (params: any) => {
          const airline = params.data?.airline_name?.toLowerCase?.();
          const otpPass = params.data?.otp_pass;
          const notRequiredAirlines = ["klm", "airfrance", "aircanada"];
          return notRequiredAirlines.includes(airline) && (!otpPass || otpPass === "");
        },
      },
      cellRenderer: (params: ICellRendererParams) => {
        if (params?.node?.group) {
          return params.value;
        }
        const value = params.value;
        const isNotRequired = value === "__NOT_REQUIRED__";
        const isEmpty = !value || value === "";
        if (isNotRequired) {
          return (
            <span
              id="disable-cell"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                color: "#808080",
                fontSize: "14px",
                border: "1px solid var(--Neutral-300, #E8EAF1)",
                background: "rgba(128, 128, 128, 0.10)",
                padding: "2px 6px",
                borderRadius: "4px",
                width: "200px",
              }}
            >
              <ErrorIcon fontSize="small" />
              Not Required
            </span>
          );
        }
        return (
          <span style={{ color: isEmpty ? "#aaa" : "#000" }}>
            {isEmpty ? "Enter OTP password" : value}
          </span>
        );
      },
    },
    {
      headerName: "Status",
      minWidth: 200,
      enableRowGroup: true,
      checkboxSelection: false,
      valueGetter: (params: any) => {
        const { valid, portal_id, portal_pass, pendingUpdate } = params.data || {};
        if (pendingUpdate) return "Pending";
        return getCredentialStatus(valid, portal_id, portal_pass, pendingUpdate);
      },
      filter: "agSetColumnFilter",
      filterParams: {
        values: ["Valid", "Wrong Credential", "Not Available", "Pending"],
      },
      cellRenderer: (params: ICellRendererParams) => {
        if (params?.node?.group) {
          return "";
        }
        const { valid, portal_id, portal_pass, pendingUpdate } = params.data || {};
        const value = pendingUpdate
          ? "Pending"
          : getCredentialStatus(valid, portal_id, portal_pass, pendingUpdate);
        let tagProps: {
          icon: React.ReactNode;
          text: string;
          antColor: "success" | "error" | "warning" | "processing";
        };
        if (value === "Valid") {
          tagProps = {
            icon: <CheckCircleFilled />,
            text: "Valid",
            antColor: "success",
          };
        } else if (value === "Wrong Credential") {
          tagProps = {
            icon: <CloseCircleFilled />,
            text: "Wrong Credential",
            antColor: "error",
          };
        } else if (value === "Pending") {
          tagProps = {
            icon: <LoadingOutlined />,
            text: "Pending",
            antColor: "processing",
          };
        } else {
          tagProps = {
            icon: <ExclamationCircleFilled />,
            text: "Not Available",
            antColor: "warning",
          };
        }
        return (
          <Tag
            icon={tagProps.icon}
            color={tagProps.antColor}
            style={{ display: "flex", alignItems: "center", gap: 4 }}
          >
            {tagProps.text}
          </Tag>
        );
      },
    },
    {
      headerName: "Action", minWidth: 200, enableRowGroup: true, cellRenderer: (params: any) => {
        return <Button type="primary" size="small" onClick={() => handleRetry(params.data)}>Retry</Button>;
      }
    },
    {
      field: "updated_at",
      headerName: "Last Edited",
      minWidth: 300,
      enableRowGroup: true,
      cellRenderer: (params: any) => {
        const value = params.value;
        if (!value) return ""; // return empty if null or undefined
        const date = new Date(value);
        return isNaN(date.getTime()) ? "" : date.toLocaleDateString(); // return empty if invalid date
      }
    }
  ];



  const fetchData = async (isAutoRefresh = false) => {
    if (!isMounted.current) return;
    if (!isAutoRefresh) {
      setLoading(true);
    }
    try {
      const response = await apiGet(API_ENDPOINT_FETCH_AIRLINE_CREDENTIALS_LIST);
      if (response.status && Array.isArray(response.data?.credentials)) {
        const newData = response.data.credentials.map((item: any) => {
          const cleanedItem: any = {};
          for (const key in item) {
            cleanedItem[key] = item[key] ?? "";
          }
          return cleanedItem;
        });
        if (isAutoRefresh) {
          const resolvedRows = newData.filter((newRow: any) => {
            const isPendingInRef = pendingUpdatesRef.current.has(newRow.id);
            return isPendingInRef && (newRow.valid === true || newRow.valid === false);
          });
          if (resolvedRows.length > 0) {
            const movedToActive = resolvedRows.filter((newRow: any) => {
              const existingRow = originalData.find((row) => row.id === newRow.id);
              // Check if it was previously FAILED (Action Required) and now is ACTIVE (No Action Required)
              const wasFailed = existingRow?.valid === false || existingRow?.valid === null;
              const isNowActive = newRow.valid === true;
              return wasFailed && isNowActive;
            });
            if (movedToActive.length > 0) {
              setResolvedRows(movedToActive);
              setShowResolutionPopup(true);
            }
            const rowsToApply = resolvedRows.map((row: any) => ({
              ...row,
              pendingUpdate: false,
            }));
            setOriginalData((prev) => {
              const updatedOriginal = prev.map((existingRow) => {
                const resolvedRow = resolvedRows.find((row: any) => row.id === existingRow.id);
                if (resolvedRow) {
                  pendingUpdatesRef.current.delete(existingRow.id);
                  return {
                    ...existingRow,
                    ...resolvedRow,
                    pendingUpdate: false
                  };
                }
                return existingRow;
              });
              return updatedOriginal;
            });
            if (gridApi) {
              // Save expanded group keys before updating (to preserve during polling)
              const expandedGroupKeys = new Set<string>();
              gridApi.forEachNode((node: any) => {
                if (node.group && node.expanded) {
                  expandedGroupKeys.add(node.key);
                }
              });
              gridApi.applyTransactionAsync({ update: rowsToApply }, () => {
                // Restore expanded groups after transaction completes
                gridApi.forEachNode((node: any) => {
                  if (node.group && expandedGroupKeys.has(node.key)) {
                    node.setExpanded(true);
                  }
                });
              });
            }
          } else {
          }
        } else {


          const mergedData = newData.map((newRow: any) => {
            const existingRow = originalData.find((row) => row.id === newRow.id);
            return existingRow
              ? { ...newRow, pendingUpdate: existingRow.pendingUpdate || false }
              : { ...newRow, pendingUpdate: false };
          });
          setOriginalData(_cloneDeep(mergedData));
          setRowData(mergedData);
          if (gridApi) {
            // Save expanded group keys before updating
            const expandedGroupKeys = new Set<string>();
            gridApi.forEachNode((node: any) => {
              if (node.group && node.expanded) {
                expandedGroupKeys.add(node.key);
              }
            });
            gridApi.applyTransactionAsync({ update: mergedData }, () => {
              // Restore expanded groups after transaction completes
              gridApi.forEachNode((node: any) => {
                if (node.group && expandedGroupKeys.has(node.key)) {
                  node.setExpanded(true);
                }
              });
            });
          }
        }
      } else {
        setRowData([]);
      }
    } catch (error) {
      setRowData([]);
    }

    if (!isAutoRefresh) {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchData();
  }, [userDetails.currentWorkspace]);


  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = '';
      }
    };




    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [hasUnsavedChanges]);



  const handleCellEditingStarted = () => {
    //setHasUnsavedChanges(true);
    const saveBtn = document.getElementById("saveBtn");
    if (saveBtn) {
      //saveBtn.style.display = "inline-block";
      saveBtn.style.display = "flex";
      saveBtn.style.padding = "16px 40px"; // ⬅️ add padding here
      saveBtn.style.fontSize = "16px";
      saveBtn.style.borderRadius = "4px";
    }
  };


  const handleCellValueChange = (event: CellValueChangedEvent) => {
    const updatedData = [...rowData];
    const index = updatedData.findIndex(row => row.id === event.data.id);
    if (index !== -1) {
      updatedData[index] = event.data;
      setRowData(updatedData);
    }
  };

  useEffect(() => {
    if (gridRef.current) {
      setGridApi(gridRef.current.api);   // access api directly from ref
    }
  }, [gridRef.current]);


  const handleSaveClick = async () => {
    FinkAnalytics("user_clicked_airline_save_button", {
      event_category: "form_action",
      field: "airline_credential",
    });
    if (!gridApi) return;
    // Save expanded group keys before updating
    const expandedGroupKeys = new Set<string>();
    gridApi.forEachNode((node: any) => {
      if (node.group && node.expanded) {
        expandedGroupKeys.add(node.key);
      }
    });
    const editableFields = ["portal_id", "portal_pass", "code", "otp_email", "otp_pass"];
    const modifiedRows: any[] = [];
    const keyField = "id";
    setHasUnsavedChanges(false);
    const isMeaningful = (val: any) => {
      const v = (val ?? "").toString().trim();
      return v !== "" && v !== "__NOT_REQUIRED__" && v !== "0" && v.toLowerCase() !== "na";
    };
    const sanitizeRow = (row: any) => {
      const editableFields = ["portal_id", "portal_pass", "code", "otp_email", "otp_pass"];
      const sanitized = { ...row };
      editableFields.forEach(key => {
        const v = (sanitized[key] ?? "").toString().trim();
        sanitized[key] = (v === "0" || v.toLowerCase() === "na") ? "" : v;
      });
      // Apply backend sanitization to remove empty strings and 0
      return sanitizeForBackend(sanitized);
    };
    gridApi.forEachNode((node: any) => {
      // Skip nodes without data (group nodes)
      if (!node.data) {
        return;
      }
      const id = node.data[keyField];
      const original = originalData.find(item => item[keyField] === id);
      let isModified = false;
      if (original) {
        isModified = editableFields.some(key => {
          const newValue = (node.data[key] ?? "").toString().trim();
          const oldValue = (original[key] ?? "").toString().trim();
          const sanitize = (v: string) => (v === "0" || v.toLowerCase() === "na") ? "" : v;
          return sanitize(newValue) !== sanitize(oldValue);
        });
      } else {
        isModified = editableFields.some(key => isMeaningful(node.data[key]));
        if (isModified) {
        }
      }
      if (isModified) {
        node.data.pendingUpdate = true;
        node.data.updated_at = new Date().toISOString();
        modifiedRows.push(node.data);
        if (id) pendingUpdatesRef.current.add(id);
      }
    });
    if (modifiedRows.length === 0) {
      messageApi.info("No changes to save.");
      return;
    }
    try {
      const rowsToUpdate = modifiedRows.filter(row => row.id).map(sanitizeRow);
      const rowsToInsert = modifiedRows.filter(row => !row.id).map(sanitizeRow);
      // 1. Update existing rows as before
      let rowsToUpdateResponse = null;
      if (rowsToUpdate.length > 0) {
        rowsToUpdateResponse = await axios.post(API_ENDPOINT_CREDENTIAL_ADD_BULK, rowsToUpdate);
      }
      // 2. Insert new rows (no id)
      let didInsert = false;
      for (const row of rowsToInsert) {
        await handleAddCredential({
          portal_id: row.portal_id || '',
          password: row.portal_pass || '',
          code: row.code || '',
          pan: row.pan || '',
          airline_name: row.airline_name || '',
          workspace_id: userDetails?.currentWorkspace.id,
          otp_email: row.otp_email || '',
          otp_pass: row.otp_pass || '',
        });
        didInsert = true;
      }

      if (rowsToInsert.length > 0) {
        await fetchData();
        // Restore expanded groups after fetchData completes
        if (gridApi) {
          gridApi.forEachNode((node: any) => {
            if (node.group && expandedGroupKeys.has(node.key)) {
              node.setExpanded(true);
            }
          });
        }
      }
      messageApi.success("Changes saved successfully!");
      // Only update the affected rows in originalData
      if (rowsToUpdateResponse && rowsToUpdateResponse.data?.credentials) {
        setOriginalData(_cloneDeep(rowsToUpdateResponse.data.credentials));
        if (gridApi) {
          gridApi.applyTransactionAsync({ update: rowsToUpdateResponse.data.credentials }, () => {
            gridApi.forEachNode((node: any) => {
              if (node.group && expandedGroupKeys.has(node.key)) {
                node.setExpanded(true);
              }
            });
          });
        }
      } else {
        setOriginalData((prev) => {
          const updatedOriginal = prev.map((row) => {
            const modifiedRow = modifiedRows.find((modRow) => modRow.id === row.id);
            if (modifiedRow) {
              return { ...row, ...modifiedRow, pendingUpdate: true, updated_at: modifiedRow.updated_at || new Date().toISOString() };
            }
            return row;
          });
          return updatedOriginal;
        });
        // Only update the affected rows in the grid - this preserves expanded groups
        gridApi.applyTransactionAsync({ update: modifiedRows }, () => {
          // Restore expanded groups after transaction completes
          gridApi.forEachNode((node: any) => {
            if (node.group && expandedGroupKeys.has(node.key)) {
              node.setExpanded(true);
            }
          });
        });
      }
      const saveBtn = document.getElementById("saveBtn");
      if (saveBtn) saveBtn.style.display = "none";
      startAutoRefresh();
    } catch (error) {
      messageApi.error("Failed to save changes.");
    }
  };


  const startAutoRefresh = () => {
    if (refreshTimerId) clearInterval(refreshTimerId);
    const id = setInterval(() => {
      const hasPendingUpdates = pendingUpdatesRef.current.size > 0;
      if (hasPendingUpdates) {
        fetchData(true);
      } else {
        clearInterval(id);
        setRefreshTimerId(null);
      }
    }, 10000); // 10 seconds
    setRefreshTimerId(id);
  };

  // Add a new function to stop polling when status changes
  const stopAutoRefresh = () => {
    if (refreshTimerId) {
      clearInterval(refreshTimerId);
      setRefreshTimerId(null);
    }
  };

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
      if (refreshTimerId) {
        clearInterval(refreshTimerId);
        setRefreshTimerId(null);
      }
    };
  }, []);


  const handleBulkUpdateClick = () => {
    setIsBulkModalVisible(true);
  };


  const handleDownloadCsv = () => {
    if (!gridRef.current || !gridRef.current.api) {
      return;
    }
    // Get all leaf nodes (actual data rows, not group rows)
    const allLeafNodes: any[] = [];
    gridRef.current.api.forEachNode((node: any) => {
      if (!node.group && node.data) {
        allLeafNodes.push(node.data);
      }
    });
    // Use leaf nodes if available, otherwise fall back to rowData
    const dataToExport = allLeafNodes.length > 0 ? allLeafNodes : rowData;
    const visibleColumns = columnDefs.filter((col: any) => {
      if (col.field === "airline_name" || col.field === "workspace_name") {
        return true;
      }
      return col.hide !== true && col.field && col.field !== "id";
    });
    const headers = visibleColumns.map((col: any) => col.headerName || col.field);
    const rows = dataToExport.map((rowData: any) => {
      return visibleColumns.map((col: any) => {
        const value = rowData[col.field];
        if (value === null || value === undefined || value === 0 || value === "") {
          return "";
        }
        if (typeof value === "string" && value.startsWith("->")) {
          return value.replace("-> ", "");
        }
        // Format updated_at date as dd/mm/yyyy
        if (col.field === "updated_at" && value) {
          const date = new Date(value);
          if (!isNaN(date.getTime())) {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
          }
          return "";
        }
        return value;
      });
    });
    // Create workbook and worksheet using XLSX
    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "PAN List");
    XLSX.writeFile(workbook, "pan_list.xlsx");
  }

  const handleUpload = async (file: any) => {
    const selectedFile = file.originFileObj || file;
    if (!file.originFileObj) {
      const reader = new FileReader();
      reader.onload = async (e: any) => {
        const binaryString = e.target.result;
        let jsonArray;
        if (file.type.includes("csv")) {
          //@ts-ignore
          jsonArray = await csv().fromString(binaryString);
        } else if (
          file.type.includes("sheet") ||
          file.type.includes("excel") ||
          file.name.endsWith(".xls") ||
          file.name.endsWith(".xlsx")
        ) {
          const workbook = XLSX.read(binaryString, { type: "binary" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          jsonArray = XLSX.utils.sheet_to_json(worksheet);
        } else {
          return;
        }
        // Trim whitespace from each value in the JSON array
        jsonArray = jsonArray.map((row: any) => {
          return Object.fromEntries(
            Object.entries(row).map(([key, value]) => [
              key,
              typeof value === "string" ? value.trim() : value,
            ])
          );
        });
        setUploadedData(jsonArray);
        setUploadedFile(selectedFile);
      };




      reader.readAsBinaryString(file);
    }
  };

  //new---
  const handleAddCredential = async ({
    portal_id,
    password,
    code,
    pan,
    airline_name,
    workspace_id,
    otp_email,
    otp_pass
  }: {
    portal_id: string;
    password: string;
    code: string;
    pan: string;
    airline_name: string;
    workspace_id: string;
    otp_email: string;
    otp_pass: string;
  }) => {
    setIntegrating(true);
    const payload = [
      sanitizeForBackend({
        current_workspace_id: workspace_id,
        portal_id,
        otp_email: otp_email,
        otp_pass: otp_pass,
        imap_url: null,
        run_days_interval: null,
        airline_name,
        portal_pass: password,
        code,
        pan,
      })
    ];
    const response = await apiPost(
      // "http://localhost:7001/api/creds/airline/addBulk",
      API_ENDPOINT_CREDENTIAL_ADD_BULK,
      payload
    );
    if (response.status) {
      messageApi.success(`Credential added for PAN: ${pan}`);
      setPanList((prevPanList) =>
        prevPanList.map((item: any) =>
          item.pan === pan ? { ...item, portal_id: portal_id } : item
        )
      );
      setFilteredPANS((prevFilteredPANS) =>
        prevFilteredPANS.map((item: any) =>
          item.pan === pan ? { ...item, portal_id: portal_id } : item
        )
      );
      // Return the new credential if available
      if (response.data?.credential) {
        return response.data.credential;
      }
    } else {
      messageApi.error(`Failed to add credential for PAN: ${pan}`);
    }
    setIntegrating(false);
    return undefined;
  };


  const handleModalSubmit = async () => {
    if (uploadedData.length === 0) {
      messageApi.warning("No data uploaded");
      return;
    }
    try {
      const normalize = (val: any) => (val ?? "").toString().trim().toLowerCase();
      // const isValidValue = (val: any) => val !== "" && val !== "0"; // Check for valid values
      const isValidValue = (val: any) => {
        const v = (val ?? "").toString().trim();
        return v !== "" && v !== "__NOT_REQUIRED__" && v !== "0" && v.toLowerCase() !== "na";
      };
      const matchedData: any[] = [];
      const unmatchedRows: any[] = [];
      const modifiedRows: any[] = [];
      uploadedData.forEach((uploadedRow) => {
        const normalizedUploadedRow: Record<string, any> = {};
        Object.entries(uploadedRow).forEach(([key, val]) => {
          normalizedUploadedRow[key.toLowerCase()] = val;
        });




        const match = rowData.find(
          (gridRow) =>
            normalize(normalizedUploadedRow['pan']) === normalize(gridRow.pan) &&
            normalize(normalizedUploadedRow['airlines']) === normalize(gridRow.airline_name)
        );




        if (match) {
          // Check if any editable fields have changed and ignore "" or "0"
          const isModified =
            (isValidValue(normalizedUploadedRow['password']) &&
              normalize(normalizedUploadedRow['password']) !== normalize(match.portal_pass)) ||
            (isValidValue(normalizedUploadedRow['username']) &&
              normalize(normalizedUploadedRow['username']) !== normalize(match.portal_id)) ||
            (isValidValue(normalizedUploadedRow['code']) &&
              normalize(normalizedUploadedRow['code']) !== normalize(match.code)) ||
            (isValidValue(normalizedUploadedRow['pan']) &&
              normalize(normalizedUploadedRow['pan']) !== normalize(match.pan)) ||
            (isValidValue(normalizedUploadedRow['airlines']) &&
              normalize(normalizedUploadedRow['airlines']) !== normalize(match.airline_name));




          if (isModified) {
            modifiedRows.push({
              id: match.id || match._id,
              workspace_id: match.workspace_id || match.workspaceId,
              otp_email: (normalizedUploadedRow['otp email'] ?? match.otp_email ?? "").toString().trim(),
              otp_pass: (normalizedUploadedRow['otp password'] ?? match.otp_pass ?? "").toString().trim(),
              imap_url: match.imap_url,
              run_days_interval: match.run_days_interval,




              airline_name: (normalizedUploadedRow['airlines'] ?? match.airline_name ?? "").toString().trim(),
              portal_pass: (normalizedUploadedRow['password'] ?? match.portal_pass ?? "").toString().trim(),
              portal_id: (normalizedUploadedRow['username'] ?? match.portal_id ?? "").toString().trim(),
              code: (normalizedUploadedRow['code'] ?? match.code ?? "").toString().trim(),
              pan: (normalizedUploadedRow['pan'] ?? match.pan ?? "").toString().trim(),
            });
          }
        } else {
          // New row (not found in existing data)
          unmatchedRows.push(normalizedUploadedRow);
        }
      });




      // Update modified rows
      if (modifiedRows.length > 0) {
        const sanitizedModifiedRows = modifiedRows.map(sanitizeForBackend);

        const response = await axios.post(
          API_ENDPOINT_CREDENTIAL_ADD_BULK,
          // "http://localhost:7001/api/creds/airline/addBulk",
          sanitizedModifiedRows
        );




        messageApi.success("Bulk update successful!");




        if (response.data?.credentials) {
          setRowData(response.data.credentials);
          setOriginalData(_cloneDeep(response.data.credentials));
        }
      }




      // Add new rows
      for (const row of unmatchedRows) {
        await handleAddCredential({
          portal_id: row['username'] || '',
          password: row['password'] || '',
          code: row['code'] || '',
          pan: row['pan'] || '',
          airline_name: row['airlines'] || '',
          workspace_id: userDetails?.currentWorkspace.id,
          otp_email: row['otp_email'] || '',
          otp_pass: row['otp_pass'] || '',
        });
      }




      setIsBulkModalVisible(false);
      setUploadedData([]);




    } catch (error) {
      messageApi.error("Bulk update failed.");
    }
  };




  useEffect(() => {
    const filtered = originalData.filter((item) => {
      const { valid, portal_id, portal_pass } = item;




      const status = (!portal_id || !portal_pass)
        ? "NA"
        : valid === true
          ? "Active"
          : valid === false
            ? "In Active"
            : null; // explicitly handle null case




      if (activeSegment === "ACTIVE") return status === "Active";
      if (activeSegment === "FAILED") return status !== "Active"; // includes "NA", "In Active", and null
    });




    setRowData(filtered);
  }, [activeSegment, originalData]);








  const handleReUpload = () => {
    setUploadedFile(null);
  };




  const handleGlobalSearch = (searchValue: string) => {
    const value = searchValue.trim().toLowerCase();




    if (!value) {
      setRowData(originalData); // Reset to full data
      return;
    }




    const filteredData = originalData.filter((item: any) => {
      return (
        item.airline_name?.toLowerCase().includes(value) ||
        item.portal_id?.toLowerCase().includes(value) ||
        item.pan?.toLowerCase().includes(value) ||
        item.workspace_name?.toLowerCase().includes(searchValue)
      );
    });




    setRowData(filteredData);
  };

  const handleRetry = async (rowData: any) => {
    try {
      if (!rowData?.id) {
        messageApi.error("Invalid credential data. ID is missing.");
        return;
      }

      // Set row status to Pending immediately
      const updatedRow = {
        ...rowData,
        pendingUpdate: true
      };

      // Add to pending updates ref
      pendingUpdatesRef.current.add(rowData.id);

      // Update rowData state
      setRowData((prevData: any[]) =>
        prevData.map((row: any) =>
          row.id === rowData.id ? updatedRow : row
        )
      );

      // Update originalData state
      setOriginalData((prevData: any[]) =>
        prevData.map((row: any) =>
          row.id === rowData.id ? updatedRow : row
        )
      );

      // Update grid to show Pending status
      if (gridApi) {
        gridApi.applyTransactionAsync({ update: [updatedRow] });
      }

      const response = await apiPost("https://stage-apiplatform.finkraftai.com/api/meta/retryCredsStatus", {
        id: rowData.id,
        type: "airline"
      });

      // If status is 200 (success), API returns {"message":"Credentials status updated successfully"}
      // Since apiPost returns response.json(), if we get a message, it means status 200
      if (response.message) {
        // Status 200 - show success message with tick mark
        messageApi.success(response.message);
        // Refresh the data after a short delay to get updated status
        setTimeout(() => {
          fetchData(true);
        }, 1000);
      } else {
        // Status is not 200 - show error
        messageApi.error("Credentials status not updated. Please try again.");
      }
    } catch (error: any) {
      messageApi.error(error.message || "An error occurred while submitting retry request.");
    }
  };







  return (
    <div className="IntegrationNew">
      <div className="ScreenContainer">
        <div className="MainContainer">
          <div className="AirlineHeaderSection" >
            {/* <Typography className="airlineText">Airline Credential</Typography> */}
            <Segmented
              style={{ marginLeft: '10px' }}
              options={[
                { label: "Action Required", value: "FAILED" },
                { label: "No Action Required", value: "ACTIVE" }
              ]}
              value={activeSegment}
              onChange={(value) => {
                setActiveSegment(value);
              }}
              size="small"
            />
            <div style={{ display: 'flex', gap: '10px' }}>
              <div style={{ paddingLeft: '10px', display: 'flex', justifyContent: 'flex-end' }}>
                <Input
                  placeholder="Search Airline, Username or PAN"
                  value={globalSearch}
                  onChange={(e: any) => {
                    const value = e.target.value;
                    setGlobalSearch(value);
                    handleGlobalSearch(value);
                  }}
                  allowClear
                  prefix={<SearchOutlined style={{ marginRight: '2px', color: '#72747d' }} />}
                  style={{ width: '270px' }}
                />
              </div>
              <Button
                id="saveBtn"
                type="primary"
                className="airlineSaveBtn"
                onClick={handleSaveClick}
                style={{ display: "none" }}
              >
                Save
              </Button>
              <Button id="bulkUpdateBtn" className="airlineBulkBtn" onClick={handleBulkUpdateClick}>
                Bulk Upload
              </Button>
            </div>
          </div>
          <div className="AirlineBodySection">
            <div style={{ height: '100%' }}>
              <AgTableClient
                ref={gridRef}
                //@ts-ignore
                // onGridReady={onGridReady}
                columnDefs={columnDefs}
                rowData={rowData}
                enableDirectEdit
                groupPanel
                singleClickEdit={true}
                onCellEditingStarted={handleCellEditingStarted}
                getRowId={(params: any) => params.data.id}
              />
            </div>
          </div>
        </div>
      </div>




      <Modal
        title="Bulk Upload"
        open={isBulkModalVisible}
        footer={null}
        onCancel={() => setIsBulkModalVisible(false)}
        width={500}
        style={{ width: 500 }}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#e5f6f7",
              borderRadius: "4px",
              padding: "6px 12px",
              cursor: "pointer",
              width: "fit-content",
              marginBottom: "20px",
              marginTop: "20px",
            }}
            onClick={handleDownloadCsv}
          >
            <DownloadIcon style={{ marginRight: "6px", color: "#0a8394", width: '14px', height: '18px' }} />
            <span style={{ color: "#0a8394", fontWeight: 500 }}>
              Download PAN list for credentials
            </span>
          </div>
        </div>




        {/* Upload or Uploaded file status */}
        {!uploadedFile ? (
          <Uploader onSelect={handleUpload} />
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',




            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexDirection: 'column' }}>
              <DownloadDoneIcon style={{ color: '#008000', fontSize: '20px', width: '70px', height: '80px' }} />
              {/* <span style={{ fontWeight: 500 }}>File uploaded: {uploadedFile.name}</span> */}
              <span style={{ fontWeight: 800, color: '' }}>File uploaded</span>
            </div>
            <span
              onClick={handleReUpload}
              style={{
                display: 'flex',
                alignContent: 'center',
                color: '#0a8394',
                cursor: 'pointer',
                backgroundColor: "#e5f6f7",
                borderRadius: "4px",
                padding: "4px 6px",
                marginTop: '7px',
                //fontWeight: 500,
                //textDecoration: 'underline'
              }}
            >
              Repload <FileUploadIcon />
            </span>
          </div>
        )}




        <div style={{ display: 'flex', gap: '16px', justifyContent: "space-between", marginTop: '30px' }}>
          <Button
            onClick={() => setIsBulkModalVisible(false)}
            style={{
              padding: '17px 60px',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '8px',
              fontSize: '16px',
              color: '#0A8394',
              borderColor: '#0A8394'
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleModalSubmit}
            //disabled={!uploadedFile}
            style={{
              padding: '18px 60px',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '8px',
              fontSize: '16px',
              color: '#FFF',
              backgroundColor: '#0A8394',
              //backgroundColor: uploadedFile ? '#0A8394' : '#ccc',
              //cursor: uploadedFile ? 'pointer' : 'not-allowed'
            }}
          >
            Submit
          </Button>
        </div>
      </Modal>




      <Modal
        title="🎉 Credentials Resolved!"
        open={showResolutionPopup}
        onCancel={() => setShowResolutionPopup(false)}
        footer={[
          <Button key="ok" type="primary" onClick={() => setShowResolutionPopup(false)}>
            Great!
          </Button>
        ]}
        width={500}
      >
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <CheckCircleFilled style={{ fontSize: '48px', color: '#52c41a', marginBottom: '16px' }} />
          <h3>Action No Longer Required</h3>
          <p>The following credentials have been successfully resolved:</p>
          <div style={{ marginTop: '16px', textAlign: 'left' }}>
            {resolvedRows.map((row, index) => (
              <div key={row.id} style={{
                padding: '8px 12px',
                backgroundColor: '#f6ffed',
                border: '1px solid #b7eb8f',
                borderRadius: '4px',
                marginBottom: '8px'
              }}>
                <strong>{row.airline_name}</strong> - {row.pan}
              </div>
            ))}
          </div>
          <p style={{ marginTop: '16px', color: '#666' }}>
            These credentials are now working properly and no longer require your attention.
          </p>
        </div>
      </Modal>




      {contextHolder}
    </div>
  );
}













